import { Component } from "react";
import ComponentsPark from "../../../containers/ComponentsPark/ComponentsPark";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Button } from "@mui/material";
import qrCodeLogo from "../../../images/qr-code-icon.png";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ValidateIcon from "@mui/icons-material/Check";
import { withStyles } from "@mui/styles";
import { TYPING_TIMEOUT } from "../../../constants";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import { fieldValueChange } from "../../../redux/intervention/interventionActions";
import { compose } from "redux";
import { connect } from "react-redux";
import TextFieldWithTypingTimeout from "../../Input/TextFieldWithTypingTimeout";

const styles = {
    appBar: {
        position: "relative",
        marginBottom: "10px",
    },
    flex: {
        flex: 1,
    },
};

class InterventionEquipmentField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            selectedEquipmentCode: this.props.value.value_text,
            timeout: TYPING_TIMEOUT,
            typedJustNow: false,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let state = { ...prevState };

        if (state.typedJustNow) return state;

        let currentValue = nextProps.value.value_text;
        if (currentValue !== state.selectedEquipmentCode) {
            state.selectedEquipmentCode = currentValue;
        }

        return state;
    }

    onClick() {
        this.setState({
            equipmentCode: "",
            open: true,
        });
    }

    close() {
        this.setState({
            open: false,
        });
    }

    selectEquipment(equipmentCode) {
        this.setState({
            selectedEquipmentCode: equipmentCode,
        });

        let fieldValue = this.props.value;
        fieldValue.value_text = equipmentCode;
        this.updateOtherValuesOfBloc(equipmentCode);
        this.props.fieldValueChange(fieldValue);
        this.close();
    }

    visualizeEquipment(equipmentCode) {
        this.setState({
            equipmentCode,
        });
    }

    validateVisualizingEquipment() {
        this.selectEquipment(this.state.equipmentCode);
    }

    cancelVisualizingEquipment() {
        this.setState({
            equipmentCode: "",
        });
    }

    //Fonction spécifique pour mettre à jour d'autres champs du bloc lorsque celui-ci est modifié
    //Priorité au fonctionnement générique. Si ça ne fonctionne pas tant pis
    updateOtherValuesOfBloc(newLiquidBottleCode) {
        if (this.props.blocType.code !== "MANIP_FLUIDE") return;

        let blocValues = this.props.blocs.find((bv) => bv.mobile_id === this.props.blocId);

        if (!blocValues) return;

        if (!this.props.customerSearch) return;

        let equipment = this.props.customerSearch.component_ids.find((e) => e.code === newLiquidBottleCode);

        let descriptionFieldType = this.props.blocType.field_ids.find(
            (f) => f.code === "MANIP_FLUIDE_EQUIPEMENT_DESCRIPTION"
        );
        if (!descriptionFieldType) return;

        let descriptionValues = blocValues.field_ids.find((f) => f.type_id === descriptionFieldType.id);
        if (!descriptionValues) return;

        descriptionValues.value_text = equipment ? equipment.complete_name : "";
        this.props.specificFieldValueChange(
            blocValues.mobile_id,
            descriptionFieldType.id,
            descriptionValues,
            this.props.blocs,
            this.props.activeUser.id,
            this.props.intervention
        );

        if (!equipment) return;

        let fluidTypeFieldType = this.props.blocType.field_ids.find(
            (f) => f.code === "MANIP_FLUIDE_EQUIPEMENT_TYPE_FLUIDE"
        );
        if (!fluidTypeFieldType) return;

        let fluidTypeValues = blocValues.field_ids.find((f) => f.type_id === fluidTypeFieldType.id);
        if (!fluidTypeValues) return;

        let choice = fluidTypeFieldType.choice_ids.find((c) => c.code === equipment.attributes.LIQUID_TYPE);

        if (choice) fluidTypeValues.value_choice_id = choice.id;

        this.props.specificFieldValueChange(
            blocValues.mobile_id,
            fluidTypeFieldType.id,
            fluidTypeValues,
            this.props.blocs,
            this.props.activeUser.id,
            this.props.intervention
        );

        let chargeTotalFieldType = this.props.blocType.field_ids.find(
            (f) => f.code === "MANIP_FLUIDE_EQUIPEMENT_CHARGE_INIT"
        );
        if (!chargeTotalFieldType) return;

        let chargeTotalValues = blocValues.field_ids.find((f) => f.type_id === chargeTotalFieldType.id);
        if (!chargeTotalValues) return;

        chargeTotalValues.value_float = equipment.attributes.QTY_KG;
        this.props.specificFieldValueChange(
            blocValues.mobile_id,
            chargeTotalFieldType.id,
            chargeTotalValues,
            this.props.blocs,
            this.props.activeUser.id,
            this.props.intervention
        );
    }

    handleChange(value) {
        let fieldValue = this.props.value;
        fieldValue.value_text = value;
        this.props.fieldValueChange(fieldValue);
        this.updateOtherValuesOfBloc(value);
        this.setState({ typedJustNow: false });
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        const { classes } = this.props;

        return (
            <div className="row">
                <div className="col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding">
                    <TextFieldWithTypingTimeout
                        value={this.state.selectedEquipmentCode}
                        onValueChange={this.handleChange.bind(this)}
                        {...this.props.inputProperties}
                        label={this.props.model.name}
                        className={this.props.inputProperties.className + " full_size control-margin-top"}
                    />
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn without-side-padding">
                    <Button
                        variant="contained"
                        size="small"
                        className="white_button"
                        onClick={this.onClick.bind(this)}
                        {...this.props.inputProperties}
                    >
                        <img src={qrCodeLogo} alt="QR code" width={32} height={32} />
                    </Button>
                </div>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    fullScreen
                    aria-labelledby="form-dialog-title"
                >
                    <AppBar className={classes.appBar} elevation={0}>
                        <Toolbar>
                            <IconButton color="inherit" onClick={this.close.bind(this)} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" className={classes.flex}>
                                {"Equipement"}
                            </Typography>
                            <IconButton
                                color="inherit"
                                onClick={this.validateVisualizingEquipment.bind(this)}
                                aria-label="Validate"
                            >
                                <ValidateIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Toolbar />
                    <DialogContent className="without-side-padding">
                        <ComponentsPark
                            modalMode
                            selectEquipment={this.selectEquipment.bind(this)}
                            visualizeEquipment={this.visualizeEquipment.bind(this)}
                            cancelVisualizingEquipment={this.cancelVisualizingEquipment.bind(this)}
                        />
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        blocs: state.intervention.blocs,
        intervention: state.intervention.currentIntervention,
        activeUser: state.activeUser,
        customerSearch: state.tiers.customerSearch,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        specificFieldValueChange: (blocId, fieldId, value, blocs, userId, intervention) =>
            dispatch(fieldValueChange(blocId, fieldId, value, blocs, userId, intervention)),
    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(InterventionEquipmentField);
